import "./App.css";

import { BrowserRouter as Router } from "react-router-dom";
import Body from "./Body";
import { useEffect, useState } from "react";
import { ZoomMtg } from "@zoomus/websdk";

function App() {
  const [subfolder, setSubFolder] = useState(process.env.PUBLIC_URL);

  // useEffect(() => {
  ZoomMtg.setZoomJSLib("https://source.zoom.us/2.5.0/lib", "/av");
  ZoomMtg.preLoadWasm();
  ZoomMtg.prepareWebSDK();

  ZoomMtg.i18n.load("it-IT");
  ZoomMtg.i18n.reload("it-IT");
  // });

  return (
    <>
      <Router>
        <Body subfolder={subfolder}></Body>
      </Router>
    </>
  );
}

export default App;
